import { render, staticRenderFns } from "./GStudentRecordScoreComparison.vue?vue&type=template&id=458739ed&scoped=true&"
import script from "./GStudentRecordScoreComparison.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordScoreComparison.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentRecordScoreComparison.vue?vue&type=style&index=0&id=458739ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458739ed",
  null
  
)

export default component.exports